const tenantLabels = {
  school: {
    university: 'Board / District',
    universityAdmin: 'Board Admin',
    college: 'School',
    collegeAdmin: 'School Admin',
    institution: 'School',
    institutionAdmin: 'School Admin',
    department: 'Class / Grade',
    departmentAdmin: 'Class Teacher',
    hod: 'Class Teacher',
    coe: 'Exam Coordinator',
    moderator: 'Moderator',
    subject_matter_expert: 'Subject Matter Expert',
    examiner: 'Examiner',
    collegeCreation: 'School Management',
    certification: 'Assessment Verification',
    subjectCreation: 'Subject Setup',
    tenantLabel: 'School'
  },
  private: {
    university: 'Parent Organization',
    universityAdmin: 'Org Admin',
    college: 'Institute',
    collegeAdmin: 'Institute Admin',
    institution: 'Institute',
    institutionAdmin: 'Institute Admin',
    department: 'Department',
    departmentAdmin: 'Dept Head',
    hod: 'Dept Head',
    coe: 'Exam Manager',
    moderator: 'Moderator',
    subject_matter_expert: 'Subject Matter Expert',
    examiner: 'Examiner',
    collegeCreation: 'Institute Management',
    certification: 'Verification',
    subjectCreation: 'Subject Setup',
    tenantLabel: 'Institute'
  },
  other: {
    university: 'Governing Body',
    universityAdmin: 'Admin',
    college: 'Institution',
    collegeAdmin: 'Institution Admin',
    institution: 'Institution',
    institutionAdmin: 'Institution Admin',
    department: 'Department',
    departmentAdmin: 'Dept Head',
    hod: 'Dept Head',
    coe: 'Exam Officer',
    moderator: 'Moderator',
    subject_matter_expert: 'Subject Matter Expert',
    examiner: 'Examiner',
    collegeCreation: 'Institution Management',
    certification: 'Verification',
    subjectCreation: 'Subject Setup',
    tenantLabel: 'Institution'
  },
  college: {
    university: 'University',
    universityAdmin: 'University Admin',
    college: 'College',
    collegeAdmin: 'College Admin',
    institution: 'College',
    institutionAdmin: 'College Admin',
    department: 'Department',
    departmentAdmin: 'HOD',
    hod: 'HOD',
    coe: 'Controller of Examinations',
    moderator: 'Moderator',
    subject_matter_expert: 'Subject Matter Expert',
    examiner: 'Examiner',
    collegeCreation: 'College Management',
    certification: 'Certification',
    subjectCreation: 'Subject Setup',
    tenantLabel: 'College'
  },
  university: {
    university: 'University',
    universityAdmin: 'University Admin',
    college: 'College',
    collegeAdmin: 'College Admin',
    institution: 'University',
    institutionAdmin: 'University Admin',
    department: 'Department',
    departmentAdmin: 'HOD',
    hod: 'HOD',
    coe: 'Controller of Examinations',
    moderator: 'Moderator',
    subject_matter_expert: 'Subject Matter Expert',
    examiner: 'Examiner',
    collegeCreation: 'College Management',
    certification: 'Certification',
    subjectCreation: 'Subject Setup',
    tenantLabel: 'University'
  }
};

export function getTenantLabels(tenantType) {
  return tenantLabels[tenantType] || tenantLabels.university;
}

export function getLabel(tenantType, key) {
  const labels = getTenantLabels(tenantType);
  return labels[key] || labels[key] || key;
}
